import React, { useContext } from 'react';
import useImage from '../../common/images/useImage';
import LazyImageContext from '../../common/LazyImageContext';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { combineClassNames } from 'core/css';
import FallbackCgi from '../../common/cgi/FallbackCgi';

const SummaryInteriorCgi = ({ cgiImageUrl, onClick }) => {
  const { hasError } = useImage(cgiImageUrl);
  const { afterLoad, loadedImages, scrollPosition } = useContext(
    LazyImageContext
  );

  if (hasError) {
    return <FallbackCgi transparent />;
  }

  return (
    <>
      <LazyLoadImage
        className={combineClassNames(
          'summary-cgi__large',
          loadedImages && !loadedImages.get(cgiImageUrl)
            ? 'summary-cgi--fadeIn'
            : '',
          'hide-print'
        )}
        src={cgiImageUrl}
        alt="vehicle interior"
        scrollPosition={scrollPosition}
        visibleByDefault={loadedImages && loadedImages.get(cgiImageUrl)}
        afterLoad={afterLoad ? () => afterLoad(cgiImageUrl) : null}
        onClick={onClick}
      />
      <img
        className={combineClassNames('summary-cgi__large', 'show-print')}
        alt="vehicle interior"
        src={cgiImageUrl}
      />
    </>
  );
};

export default SummaryInteriorCgi;
